import { render, staticRenderFns } from "./ModalAgregacaoItemBemPermanente.vue?vue&type=template&id=59a4df20"
import script from "./ModalAgregacaoItemBemPermanente.vue?vue&type=script&lang=js"
export * from "./ModalAgregacaoItemBemPermanente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports